import {inject, Injectable} from '@angular/core';
import {ServiceCase} from '../../service-case/models/service-case';
import {UserData} from '../../user/models/user-data';
import {UserService} from '../../user/services/user.service';
import {VehicleWarningLoader} from '../../vehicle-warning/services/vehicle-warning.loader';
import {WarrantyRestriction} from '../interfaces/warranty-restriction';
import {WarrantyRestrictionService} from './warranty-restriction.service';

@Injectable({
  providedIn: 'root'
})
export class WarrantyRestrictionLoader {
  private readonly warrantyRestrictionService: WarrantyRestrictionService = inject(WarrantyRestrictionService);
  private readonly userService: UserService = inject(UserService);
  private readonly vehicleWarningLoader: VehicleWarningLoader = inject(VehicleWarningLoader);

  loadWarrantyRestrictionsInServiceCase(serviceCase: ServiceCase): Promise<boolean> {
    if (!serviceCase.getVinLong()) {
      return Promise.resolve(this.updateWarrantyRestrictionsInServiceCase(serviceCase, null));
    }

    const user: UserData = this.userService.getCurrentUser();
    return new Promise(resolve => {
      this.warrantyRestrictionService.getWarrantyRestrictions(
        serviceCase.getVinLong(),
        user.getLocale(),
        user.getB2XCountryCode(),
        user.getBusinessPartner()
      )
        .then((warrantyRestrictions: WarrantyRestriction[]) => resolve(this.updateWarrantyRestrictionsInServiceCase(
            serviceCase,
            warrantyRestrictions
          ))
        )
        .catch(errors => {
          this.logBackendErrors(errors);
          resolve(this.updateWarrantyRestrictionsInServiceCase(serviceCase, undefined));
        });
    });
  }

  private updateWarrantyRestrictionsInServiceCase(serviceCase: ServiceCase,
                                                  warrantyRestrictions: WarrantyRestriction[]): boolean {
    serviceCase.setWarrantyRestrictions(warrantyRestrictions);
    return this.vehicleWarningLoader.addWarrantyRestrictionWarningsToServiceCase(serviceCase);
  }

  private logBackendErrors(errors: any[]): void {
    errors?.forEach((error: any): void => console.log(error.message));
  }
}
